import * as ACT from '../actions/productActions';

export function product(state = {}, action) {
    switch (action.type) {


        case ACT.CATEGORY_SET_ITEM:
            return {
                ...state,
                categoryTargetItem: action.data,
            };
        case ACT.CATEGORY_GET_ITEM:
            return {
                ...state,
                categoryGetItem: action.data,
            };
        case ACT.CATEGORY_ADD_ITEM:
            return {
                ...state,
                categoryAddItem: action.data,
            };
        case ACT.CATEGORY_SET_ALL:
            return {
                ...state,
                categoryList: action.data,
            };


        case ACT.PRODUCT_SET_ITEM:
            return {
                ...state,
                targetItem: action.data,
            };
        case ACT.PRODUCT_GET_ITEM:
            return {
                ...state,
                getItem: action.data,
            };
        case ACT.PRODUCT_ADD_ITEM:
            return {
                ...state,
                addItem: action.data,
            };
        case ACT.PRODUCT_SET_ALL:
            return {
                ...state,
                list: action.data,
            };


        case ACT.PRODUCT_FIELD_ERROR:
            if (state.fieldsError)
                var fieldsErrorPushed = state.fieldsError;
            else
                fieldsErrorPushed = {};
            fieldsErrorPushed[action.fieldName] = (action.fieldData != {}) ? action.fieldData : {err: true};


            return {
                ...state,
                fieldsError: fieldsErrorPushed,
                formError: true,
            };
        case ACT.PRODUCT_FIELD_RESET_ERROR:
            return {
                ...state,
                fieldsError: {},
                formError: false,
            };


        default:
            return state
    }
};
